module.exports = __webpack_public_path__ + "img/p2-87.4e9fb27a.png";